import { Link } from "@inertiajs/react"

interface FooterProps {
  brand: { line1: string; line2: string }
  nav: { services: string; agency: string; contact: string }
  footer: {
    description: string
    navigation: string
    contact: string
    copyright: string
    legal: string
    privacy: string
  }
  contactEmail: string
  paths: {
    mentionsLegales: string
    confidentiality: string
  }
}

export default function Footer({
  brand,
  nav,
  footer,
  contactEmail,
  paths,
}: FooterProps) {
  const year = new Date().getFullYear()

  return (
    <footer className="bg-contrast text-light py-16">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          <div>
            <div className="text-2xl font-bold tracking-tight mb-4">
              <span>{brand.line1}</span>
              <span className="font-light ml-1">{brand.line2}</span>
            </div>
            <p className="text-light/70 text-sm leading-relaxed">
              {footer.description}
            </p>
          </div>

          <div>
            <h3 className="font-medium mb-4 text-light">{footer.navigation}</h3>
            <ul className="space-y-2">
              <li>
                <a
                  href="/#services"
                  className="text-light/70 hover:text-light transition-colors text-sm"
                >
                  {nav.services}
                </a>
              </li>
              <li>
                <a
                  href="/#about"
                  className="text-light/70 hover:text-light transition-colors text-sm"
                >
                  {nav.agency}
                </a>
              </li>
              <li>
                <a
                  href="/#contact"
                  className="text-light/70 hover:text-light transition-colors text-sm"
                >
                  {nav.contact}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-medium mb-4 text-light">{footer.contact}</h3>
            <ul className="space-y-2">
              <li className="flex items-center gap-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-4 h-4 text-light/50"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"
                  />
                </svg>
                <a
                  href={`mailto:${contactEmail}`}
                  className="text-light/70 hover:text-light text-sm transition-colors"
                >
                  {contactEmail}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-light/10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-light/50 text-sm">
              © {year} {footer.copyright}
            </div>

            <div className="flex gap-6">
              <Link
                href={paths.mentionsLegales}
                className="text-light/50 hover:text-light text-sm transition-colors"
              >
                {footer.legal}
              </Link>
              <Link
                href={paths.confidentiality}
                className="text-light/50 hover:text-light text-sm transition-colors"
              >
                {footer.privacy}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}
